import React from 'react';
import type { CubeQuerySchema } from 'shared/src/api/cube-query-schema';
import type { LabeledTableViz } from 'shared/src/api/ai-labeled-viz-types';
import { VisualizationBlock } from '@/features/ai/visualization/visualization-block';

const QUERY: CubeQuerySchema = {
  measures: [
    'media_buy_metrics_daily.actual_spend',
    'media_buy_metrics_daily.impressions',
    'media_buy_metrics_daily.clicks'
  ],
  dimensions: [
    'media_buys.id',
    'media_buys.name',
    'media_buys.platform_name',
    'media_buys.campaign_numbers'
  ],
  timeDimensions: [{ dimension: 'media_buy_metrics_daily.day', dateRange: 'last 6 months' }],
  filters: [
    { member: 'media_buy_metrics_daily.line_item_id', operator: 'notSet' },
    { member: 'media_buy_metrics_daily.actual_spend', operator: 'gt', values: ['0'] }
  ],
  order: [['media_buy_metrics_daily.actual_spend', 'desc']]
};

const VIZ: LabeledTableViz = {
  vizType: 'table',
  title: 'Media Buys with Actual Spend (Last 6 Months) Not Linked to Any Line Item',
  columns: [
    { key: 'media_buys.name', label: 'Media Buy Name', format: 'number' },
    { key: 'media_buys.platform_name', label: 'Platform Name', format: 'number' },
    { key: 'media_buys.campaign_numbers', label: 'Campaign Numbers', format: 'number' },
    { key: 'media_buy_metrics_daily.actual_spend', label: 'Actual Spend', format: 'currency' },
    { key: 'media_buy_metrics_daily.impressions', label: 'Impressions', format: 'number' },
    { key: 'media_buy_metrics_daily.clicks', label: 'Clicks', format: 'number' }
  ]
};

export function UnlinkedMedia() {
  return (
    <div className="mx-auto w-full max-w-7xl px-6 py-6">
      <VisualizationBlock
        cubeQuery={QUERY}
        vizStatus="complete"
        visualization={{ query: QUERY, labeledViz: VIZ }}
      />
    </div>
  );
}
